export const SOCIAL_PRODUCT_NAME = 'TRB Today';
export const SOCIAL_PRODUCT_SUBTITLE = 'by The Record Base';
export const SOCIAL_PRODUCT_LABEL = `${SOCIAL_PRODUCT_NAME} ${SOCIAL_PRODUCT_SUBTITLE}`;

function TrbTodayMark({ compact = false }) {
  return (
    <span
      aria-hidden="true"
      className={`${compact ? 'h-8 w-8 rounded-lg' : 'h-11 w-11 rounded-xl'} relative flex shrink-0 items-center justify-center overflow-hidden bg-gradient-to-br from-[#666666] via-[#3a3a3a] to-[#171717] shadow-[0_10px_28px_rgba(0,0,0,0.34)] ring-1 ring-white/20`}
    >
      <span className="absolute inset-0 bg-[radial-gradient(circle_at_25%_15%,rgba(255,255,255,0.35),transparent_42%)]" />
      <span className="relative flex h-5 w-5 items-center justify-center gap-[2px]">
        <span className="h-2 w-[3px] rounded-full bg-white/80" />
        <span className="h-4 w-[3px] rounded-full bg-white" />
        <span className="h-3 w-[3px] rounded-full bg-white/90" />
        <span className="h-5 w-[3px] rounded-full bg-white" />
        <span className="h-2.5 w-[3px] rounded-full bg-white/80" />
      </span>
    </span>
  );
}

export function SocialBrandLockup({ compact = false, hideSubtitle = false, className = '' }) {
  return (
    <span className={`inline-flex min-w-0 items-center gap-3 ${className}`}>
      <TrbTodayMark compact={compact} />
      <span className="min-w-0 leading-none">
        <span className={`${compact ? 'text-sm' : 'text-base'} block truncate font-unbounded font-black tracking-[0.08em] text-white`}>{SOCIAL_PRODUCT_NAME}</span>
        {!hideSubtitle ? <span className="mt-1 block truncate text-[10px] font-semibold uppercase tracking-[0.18em] text-[#a3a3a3]">{SOCIAL_PRODUCT_SUBTITLE}</span> : null}
      </span>
    </span>
  );
}

export { TrbTodayMark };
